import type { AppointmentItem } from '../../appointments/appointments-model'
import styles from './StatusMeter.module.css'

export type StatusCounts = {
  total: number
  confirmed: number
  scheduled: number
  unknown: number
  cancelled: number
}

export function statusCounts(items: AppointmentItem[]): StatusCounts {
  const counts = {
    total: items.length,
    confirmed: 0,
    scheduled: 0,
    unknown: 0,
    cancelled: 0,
  }
  for (const item of items) {
    if (item.status === 'confirmed') counts.confirmed += 1
    else if (item.status === 'scheduled') counts.scheduled += 1
    else if (item.status === 'cancelled') counts.cancelled += 1
    else counts.unknown += 1
  }
  return counts
}

const SEGMENTS = ['confirmed', 'scheduled', 'unknown', 'cancelled'] as const
const LABELS = {
  confirmed: 'confirmed',
  scheduled: 'scheduled',
  unknown: 'status unavailable',
  cancelled: 'cancelled',
} as const

/**
 * The day's status mix as one thin bar in the approved status colors. It is
 * decorative: the count and "N confirmed" beside it carry the information.
 */
export function StatusMeter({ counts }: { counts: StatusCounts }) {
  if (!counts.total) return null
  const title = SEGMENTS.filter((key) => counts[key])
    .map((key) => `${counts[key]} ${LABELS[key]}`)
    .join(' · ')
  return (
    <span className={styles.meter} aria-hidden="true" title={title}>
      {SEGMENTS.map((key) =>
        counts[key] ? (
          <i key={key} data-status={key} style={{ flexGrow: counts[key] }} />
        ) : null
      )}
    </span>
  )
}
